<div class="space-y-2">
  <!-- Selected Storages as Chips -->
  @if (selectedStoragesLocal().length > 0) {
  <div class="mb-3 flex flex-wrap gap-2 rounded-md border border-border p-3">
    <div class="flex flex-wrap gap-2">
      @for (storage of selectedStoragesLocal(); track storage.id) {
      <div
        class="ks-chip"
      >
        <span>{{ storage.name }} ({{ storage.size }}kWh)</span>
        <button
          type="button"
          class="hover:opacity-70 transition-opacity"
          (click)="removeStorage(storage.id, $event)"
        >
          <ng-icon name="lucideX" class="w-4 h-4"></ng-icon>
        </button>
      </div>
      }
    </div>
  </div>
  }

  <!-- Popover Container -->
  <brn-popover
    #popover
    sideOffset="5"
  >
    <!-- Trigger Button -->
    <button
      type="button"
      class="ks-select-trigger"
      [disabled]="isButtonDisabled()"
      brnPopoverTrigger
    >
      <span class="truncate">
        @if (isLoading()) {
        <span class="flex items-center gap-2">
          <div
            class="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin"
          ></div>
          Lädt...
        </span>
        } @else {
        <ng-icon name="lucidePlus" class="w-4 h-4 mr-1"></ng-icon>
        Speicher hinzufügen }
      </span>
      <ng-icon name="lucideChevronDown" class="w-4 h-4"></ng-icon>
    </button>

    <!-- Command Content -->
    <div
      hlmPopoverContent
      class="ks-menu-panel w-full min-w-[400px] p-0"
      *brnPopoverContent="let ctx"
    >
      <hlm-command>
        <!-- Search -->
        <hlm-command-search>
          <ng-icon
            hlm
            name="lucideSearch"
            class="shrink-0 opacity-50"
          ></ng-icon>
          <input
            type="text"
            hlm-command-search-input
            placeholder="Speicher suchen"
            [(ngModel)]="searchValue"
          />
        </hlm-command-search>

        <hlm-command-list>
          <!-- Error State -->
          @if (error()) {
          <p class="px-3 py-3 text-xs leading-normal text-destructive">{{ error() }}</p>
          }

          <!-- Storages Section -->
          @if (!error()) { @if (storages() && storages().length > 0) {
          <!-- Storages Group -->
          <hlm-command-group>
            <hlm-command-group-label
              >Verfügbare Speicher ({{
                storages().length
              }})</hlm-command-group-label
            >

            @for (storage of filteredStorages(); track storage.id) {
            <button
              hlm-command-item
              [value]="getStorageSearchValue(storage)"
              [style.background-color]="
                isStorageSelected(storage.id) ? null : 'transparent'
              "
              [class.bg-accent]="isStorageSelected(storage.id)"
              (click)="toggleStorage(storage)"
              [disabled]="
                !isStorageSelected(storage.id) &&
                selectedStoragesLocal().length >= maxStorages()
              "
            >
              <ng-icon
                hlm
                name="lucideBatteryCharging"
                hlmCommandIcon
              ></ng-icon>
              <div class="flex-1 text-left">
                <p class="text-sm font-normal truncate">
                  {{ storage.name }}
                </p>
                <p class="text-xs text-muted-foreground truncate">
                  {{ storage.size }} kWh @if (storage.power) { •
                  {{ storage.power }} kW } • {{ storage.cost }} €
                </p>
              </div>
              @if (isStorageSelected(storage.id)) {
              <ng-icon
                hlm
                name="lucideCheck"
                class="w-4 h-4 text-primary flex-shrink-0"
              ></ng-icon>
              }
            </button>
            }
          </hlm-command-group>
          } @else if (!isLoading()) {
          <!-- Empty state -->
          <div *brnCommandEmpty hlmCommandEmpty>
            Keine Speicher vorhanden
          </div>
          } }
        </hlm-command-list>
      </hlm-command>
    </div>
  </brn-popover>
</div>
